import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { AuthHeaders } from '../../../models/auth-headers';
import { selectData } from '../../../utils/select-data';
import { copilotOnroadEventAlertSchema } from '../schemas/copilot-onroad-event-alerts.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Loads CoPilot Support Onroad Event Alerts
 * @returns An array of the Support Onroad Event Alerts
 */
export function getSupportCopilotOnroadEventAlerts(this: unknown) {
  return fromFetch(
    new Request(
      accountsEnvironment.resolve(this).supportCopilotOnroadEventAlertsUrl,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(copilotOnroadEventAlertSchema)));
}
